module.exports = __webpack_public_path__ + "img/C.169cef11.png";